import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ConfirmationIcon = 'lock' | 'user-add' | 'heart' | 'warning' | 'info';

@Component({
  selector: 'app-confirmation-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-popup.html',
  // Everything this renders is `position: fixed`, so the host must not generate
  // a box. Without this it is an inline element that gets blockified into a
  // real grid item wherever it sits inside a grid (e.g. the "All" page's shared
  // masonry grid), leaving an empty cell — a visible gap between cards.
  styles: [':host { display: contents; }'],
})
export class ConfirmationPopup {

  @Input() isOpen = false;
  @Input() icon: ConfirmationIcon = 'lock';
  @Input() title = 'Login Required';
  @Input() message = 'To continue, you need to be logged in first.';
  @Input() highlightedName = '';
  @Input() messageSuffix = '';
  @Input() confirmLabel = 'Log In';
  @Input() cancelLabel = 'Close';
  @Input() closeOnBackdrop = true;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void { this.confirmed.emit(); }
  onCancel(): void { this.cancelled.emit(); }
  onBackdropClick(): void { if (this.closeOnBackdrop) this.cancelled.emit(); }
}